import moment from 'moment';

const formatCycleRuntimeData = (cycles, dateTimes) => {
  const cycleData = [];

  if (cycles?.length > 0) {
    cycles.forEach((cycle, idx) => {
      const cycleStartTime = moment(cycle.startTime).valueOf();
      const cycleEndTime = moment(cycle.endTime).valueOf();

      const obj = {};
      if (dateTimes.includes(cycleStartTime) && dateTimes.includes(cycleEndTime)) {
        obj.from = dateTimes.indexOf(cycleStartTime);
        obj.fromValue = cycleStartTime;
        obj.to = dateTimes.indexOf(cycleEndTime);
        obj.toValue = cycleEndTime;
      }
      obj.color = '#DBE4FF';

      if (cycle.acMode === 'Cool') {
        obj.color = 'rgba(9, 70, 241, 0.52)';
      } else if (cycle.acMode === 'Heat') {
        obj.color = 'rgba(247, 7, 50, 0.44)';
      } else if (cycle.acMode === 'Fan') {
        obj.color = 'rgba(227, 234, 252, 0.46)';
      }

      obj.id = `plot-band-${idx + 1}`;

      cycleData.push(obj);
    });
  }

  return cycleData;
};

export default formatCycleRuntimeData;
